// test2673
(2673 && 0);
